export var RESOURCE_CHANGES_REPOSITORY = 'RESOURCE_CHANGES_REPOSITORY';